import { ModuleWithProviders, NgModule } from '@angular/core';
import { GRAPH_CLIENT, GraphNamedClientConfig } from '@x/common/graph';
import { ShopAdService } from './services/shop-ad.service';
import { ShopAssociationsService } from './services/shop-associations.service';
import { ShopChannelService } from './services/shop-channel.service';
import { ShopCheckoutOrderService } from './services/shop-checkout-order.service';
import { ShopCollectionService } from './services/shop-collection.service';
import { ShopMemberService } from './services/shop-member.service';
import { ShopMembershipService } from './services/shop-membership.service';
import { ShopOrderService } from './services/shop-order.service';
import { ShopPaymentService } from './services/shop-payment.service';
import { ShopProductSearchService } from './services/shop-product-search.service';
import { ShopProductService } from './services/shop-product.service';
import { ShopRegionService } from './services/shop-region.service';
import { ShopShippingMethodService } from './services/shop-shipping-method.service';
import { ShopSubscriberService } from './services/shop-subscriber.service';
import { ShopSubscriptionService } from './services/shop-subscription.service';
import { ShopTaxonService } from './services/shop-taxon.service';
import { ShopUserService } from './services/shop-user.service';
import { ShopVoucherService } from './services/shop-voucher.service';
import { ShopWalletService } from './services/shop-wallet.service';
import { ShopWishlistService } from './services/shop-wishlist.service';

export interface EcommerceShopClientModuleConfig {
  graphUrl?: string;
}

@NgModule({})
export class EcommerceShopClientModule {
  static forRoot(
    config: EcommerceShopClientModuleConfig,
  ): ModuleWithProviders<EcommerceShopClientModule> {
    const clientConfig: GraphNamedClientConfig = {
      name: 'ecommerce',
      uri: config.graphUrl ?? '/ecommerce/graphql',
      defaultOptions: {
        query: { fetchPolicy: 'no-cache', errorPolicy: 'none', returnPartialData: false },
      },
      retry: {
        enabled: true,
        queries: {
          maxRetries: 4,
          retryOnStatus: [0, 429, 503],
        },
        mutations: {
          maxRetries: 2,
          retryOnStatus: [0, 503],
        },
      },
    };

    return {
      ngModule: EcommerceShopClientModule,
      providers: [
        {
          provide: GRAPH_CLIENT,
          useValue: clientConfig,
          multi: true,
        },
        ShopChannelService,
        ShopProductService,
        ShopTaxonService,
        ShopMembershipService,
        ShopMemberService,
        ShopUserService,
        ShopOrderService,
        ShopCheckoutOrderService,
        ShopPaymentService,
        ShopWalletService,
        ShopSubscriptionService,
        ShopSubscriberService,
        ShopVoucherService,
        ShopRegionService,
        ShopWishlistService,
        ShopCollectionService,
        ShopShippingMethodService,
        ShopProductSearchService,
        ShopAssociationsService,
        ShopAdService,
      ],
    };
  }
}
